'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Public = ({ disabled })=>{
    if (disabled) return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        children: [
            jsxRuntime.jsx("path", {
                d: "M31.2861 39.4052C38.9512 39.4052 45.165 32.9331 45.165 24.9494C45.165 16.9657 38.9512 10.4937 31.2861 10.4937C23.621 10.4937 17.4072 16.9657 17.4072 24.9494C17.4072 32.9331 23.621 39.4052 31.2861 39.4052Z",
                fill: "#E0E0E0",
                stroke: "#9E9E9E",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M15.0219 8L17.6501 10.7408C10.1166 18.5875 10.1166 31.3107 17.6501 39.1574C25.1836 47.004 37.3973 47.004 44.9308 39.1574L48 42.3565",
                stroke: "#9E9E9E",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M21.4756 35.17L41.1058 14.7192",
                stroke: "#9E9E9E",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M20.1255 16.3416C20.1255 16.3416 22.5916 31.8882 40.0617 36.169",
                stroke: "#9E9E9E",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M23.0234 13.3169C23.0234 13.3169 37.9464 15.8836 42.0596 34.0793",
                stroke: "#9E9E9E",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M31.2856 45.0425V51.9999",
                stroke: "#9E9E9E",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M25.9214 52H36.6591",
                stroke: "#9E9E9E",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M31.2861 39.4052C38.9512 39.4052 45.165 32.9331 45.165 24.9494C45.165 16.9657 38.9512 10.4937 31.2861 10.4937C23.621 10.4937 17.4072 16.9657 17.4072 24.9494C17.4072 32.9331 23.621 39.4052 31.2861 39.4052Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M15.0219 8L17.6501 10.7408C10.1166 18.5875 10.1166 31.3107 17.6501 39.1574C25.1836 47.004 37.3973 47.004 44.9308 39.1574L48 42.3565",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M21.4756 35.17L41.1058 14.7192",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M20.1255 16.3416C20.1255 16.3416 22.5916 31.8882 40.0617 36.169",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M23.0234 13.3169C23.0234 13.3169 37.9464 15.8836 42.0596 34.0793",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M31.2856 45.0425V51.9999",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M25.9214 52H36.6591",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            })
        ]
    });
};

module.exports = Public;
